import styled from 'styled-components';

// top border balances spacing on active tab
export default styled.ul`
  display: flex;
  margin: 0;
  border-top: 3px solid ${props => props.theme.white};
`;
